import { render } from "./hpValue.vue?vue&type=template&id=e452705e&scoped=true"
import script from "./hpValue.vue?vue&type=script&lang=js"
export * from "./hpValue.vue?vue&type=script&lang=js"

import "./hpValue.vue?vue&type=style&index=0&id=e452705e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e452705e"]])

export default __exports__